<template>
  <div class="confirmation bg-f8f8f8 h100-full flex flex-column gray3 overflow">
    <div class="flex-auto overflow-auto" v-if="refundGoodsList">
      <div class="bg-white pad15 mar10 radius10" v-for="refundGoods in refundGoodsList">
        <div class="flex items-center justify-between pad15-b">
          <span class="gray3">商品名称：</span>
          <span>{{ refundGoods.goodsName }}</span>
        </div>
        <div class="flex items-center justify-between pad15-b">
          <span class="gray3">购买数量：</span>
          <span><span class="red">{{ refundGoods.goodsQuantityAll }} </span> {{ refundGoods.goodsSpec.split("/")[1] }} </span>
        </div>
        <div class="flex items-center justify-between pad15-b">
          <span class="gray3">成交价：</span>
          <span class="red">¥ {{ refundGoods.goodsPaidInPrice }}</span>
        </div>
        <div class="flex items-center justify-between pad15-b" v-if="refundGoods.isReceiptConfirmation === 1">
          <span class="gray3">请确认收货数量：</span>
          <div>
            <input class="input mar5-r pad5-tb pad10-lr radius5" type="text" @input="updateQuantity(refundGoods)"
                   v-model="refundGoods.confirmReceiptGoodsQuantity">
            <span> {{ refundGoods.goodsSpec.split("/")[1] }} </span>
          </div>
        </div>
        <div class="flex items-center justify-between pad15-b">
          <span class="gray3">已退还货品数量：</span>
          <span><span class="red">{{ refundGoods.goodsQuantityAccum }} </span> {{ refundGoods.goodsSpec.split("/")[1] }} </span>
        </div>
        <div class="flex items-center justify-between pad15-b">
          <span class="gray3">已退还金额：</span>
          <span class="red">¥ {{ refundGoods.goodsMoneyAccum }} </span>
        </div>
        <div class="pad10-t border-t flex items-center">
          <van-icon @click="iconToast" name="info-o"/>
          <span>本次预估返还小计</span>
          <span class="red"> ¥ {{ refundGoods.confirmReceiptGoodsMoney.toFixed(2) }}</span>
        </div>
      </div>
      <div class="bg-white pad15 mar10 radius10">
        <div class="text-right">
          <span>本次预估返还合计:</span>
          <span class="red">¥ {{ goodsMoneyAll.toFixed(2) }}</span>
        </div>
        <div class="box10"></div>
        <div class="text-right">
          <span>退款中金额:</span>
          <span class="red">¥ {{ refundingMoney }}</span>
        </div>
      </div>
  </div>
    <div class="bg-f8f8f8 pad20-tb">
      <div class="flex justify-center">
        <div class="radius5 button text-center bg-gray gray9 mar20-r" @click="routerBack">取消</div>
        <div class="radius5 button text-center bg-red white" @click="saveOrder">确定</div>
      </div>
    </div>
  </div>
</template>

<script>

import { Dialog, Toast } from "vant";

export default {

  data() {
    return {
      orderList: {},
      orderId: "",
      order: {},
      refundGoodsList: [],
      goodsMoneyAll: 0.00,
      refundingMoney: 0.00,
      returnUrl: "",
      isNotSave: false
    };
  },
  created() {
    this.orderId = this.$route.query.orderId;
    this.returnUrl = this.$route.query.returnUrl ? decodeURIComponent(this.$route.query.returnUrl) : "";
    this.selOrder();
  },
  methods: {
    selOrder() {
      // 已存在退差额商品数据
      this.$store
        .dispatch("order/refund/queryOrderGoodsList", {
          orderId: this.orderId
        })
        .then(data => {
          this.refundGoodsList = data || [];
          this.refundGoodsList.forEach((item) => {
            if (item.refundStatus === 3) {
              this.isNotSave = true;
              this.refundingMoney = Number(this.refundingMoney) + Number(item.goodsMoney);
            }
            item.confirmReceiptGoodsQuantity = Number(item.goodsQuantityAll) - Number(item.goodsQuantityAccum);
            item.confirmReceiptGoodsMoney = Number(item.goodsPaidInPrice) * (Number(item.goodsQuantityAll) - Number(item.confirmReceiptGoodsQuantity) - Number(item.goodsQuantityAccum));
            this.goodsMoneyAll = Number(this.goodsMoneyAll) + Number(item.confirmReceiptGoodsMoney);
          });
        });
    },
    updateQuantity(orderGoods) {
      const confirmReceiptGoodsQuantity = orderGoods.confirmReceiptGoodsQuantity === "" ? 0 : orderGoods.confirmReceiptGoodsQuantity;
      this.goodsMoneyAll = 0;
      orderGoods.confirmReceiptGoodsMoney = Number(orderGoods.goodsPaidInPrice) * (Number(orderGoods.goodsQuantityAll) - Number(confirmReceiptGoodsQuantity) - Number(orderGoods.goodsQuantityAccum));
      this.refundGoodsList.forEach((item) => {
        this.goodsMoneyAll = Number(this.goodsMoneyAll) + Number(item.confirmReceiptGoodsMoney);
      });
    },
    saveOrder() {
      if (this.isNotSave) {
        Toast.loading({
          mask: true,
          message: "正在退款中...",
          forbidClick: true
        });
        return;
      }
      let isSave = true;
      let isSaveMsg = "";
      this.refundGoodsList.forEach((item) => {
        if (item.isReceiptConfirmation === 1) {
          if (item.confirmReceiptGoodsQuantity === "" || Number(item.confirmReceiptGoodsQuantity) <= 0) {
            isSaveMsg = "请选择确认收货数量";
            isSave = false;
          }
          if (Number(item.confirmReceiptGoodsQuantity) + Number(item.goodsQuantityAccum) > Number(item.goodsQuantityAll)) {
            isSaveMsg = "确认收货数量已超出货品购买数量，请重新选择确认收货数量；";
            isSave = false;
          }
        }
      });
      if (!isSave) {
        Toast.fail(isSaveMsg);
        return;
      }
      Dialog.confirm({
        title: "提示",
        message: "确认收货数量后，将直接退还买家差价，且买家不支持售后，请谨慎确认！"
      }).then(() => {
        this.$store
          .dispatch("order/refund/updateOrderGoods", { orderId: this.orderId, goodsList: this.refundGoodsList })
          .then(data => {
            const { code, msg } = data;
            if (code === "0") {
              Toast.success("提交成功！");
              this.routerBack();
            } else {
              Toast({
                message: msg,
                duration: 3000
              });
            }
          }).finally(() => {
            Toast.clear();
          });
      });
    },
    routerBack() {
      const { env, returnUrl } = this;
      if (returnUrl) {
        window.location.href = returnUrl;
      } else {
        window.location.href = `${env.VUE_APP_APP}mob/mj/order/orderDetail/${this.orderId}`;
      }
    },
    iconToast() {
      Toast("实付货款=订单实付金额-平台返点");
    }
  }
};
</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>
